import { Routes } from '@angular/router';
import { Public } from './components/public/public';
import { Secure } from './components/secure/secure';
import { publicRoutes } from './components/public/public.routes';
import { secureRoutes } from './components/secure/secure.routes';

export const routes: Routes = [
    // Public Routes (Login, Forgot Password, Change Password)
    { path: '', component: Public, children: publicRoutes },

    // Secure Routes (Users, Settings, etc.)
    { path: 'ally', component: Secure, children: secureRoutes }
];